// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2r1Se","additionalInfo":"AgreementModal_additionalInfo__3vt6y"};